import { Spinner } from 'telia-front-react';
import * as React from 'react';
import { ReactNode } from 'react';

interface IDelayedLoaderProps {
  children?: React.ReactNode;
  delayMs: number;
}

interface IDelayedLoaderState {
  renderContents: boolean;
}

export default class DelayedLoader extends React.Component<IDelayedLoaderProps, IDelayedLoaderState> {
  private timeoutHandle: NodeJS.Timeout;

  constructor(props: IDelayedLoaderProps) {
    super(props);
    this.state = { renderContents: false };
  }

  public componentDidMount(): void {
    this.timeoutHandle = global.setTimeout(() => {
      this.setState({ renderContents: true });
    }, this.props.delayMs);
  }

  public componentWillUnmount(): void {
    clearTimeout(this.timeoutHandle);
  }

  public render(): JSX.Element | ReactNode {
    if (!this.state.renderContents) {
      return <Spinner />;
    }
    return this.props.children;
  }
}
